import nQueryObject from "./nQueryObject.js";

export default class nQueryWindow extends nQueryObject {
	constructor(objects) {
		super(objects);
	}
}
